<template>
    <li class="menu-subitem mb-2">
        - <a :href="href"><slot></slot></a>
    </li>
</template>

<script>
    export default {
        props: {
            href: String,
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #navigation-bar-menu .menu-item{
        
        &.open .menu-subitem{
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }

        .menu-subitem{
            font-size: 1.2rem !important;
            opacity: 0;
            transform: translate3d(-1rem, 0, 0);
            transition: opacity 1s, transform 1s;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/MenuSubitem.vue